import React, { Component } from "react";
import "./App.css";
import UIfx from "uifx";
import ButtonGroup from "./components/ButtonGroup";
import clickAudio from "./sounds/click.mp3";
import wrongAudio from "./sounds/wrong.mp3";
import successAudio from "./sounds/success.mp3";

const clicksound = new UIfx(clickAudio, {
  volume: 0.5, // number between 0.0 ~ 1.0
  throttleMs: 100,
});
const wrongsound = new UIfx(wrongAudio, {
  volume: 0.5, // number between 0.0 ~ 1.0
  throttleMs: 100,
});
const successsound = new UIfx(successAudio, {
  volume: 0.5, // number between 0.0 ~ 1.0
  throttleMs: 100,
});
class App extends Component {
  constructor(props) {
    super(props);
    this.child = React.createRef();
  }
  state = {
    ishownumber: true,
    rangeValue: 0,
    number: 0,
    iscomputer: false,
    computerRandom: 0,
    computerDeciRandom: 0,
    wins: 0,
    fails: 0,
    validated: false,
    decitext: "0,00",
    deci: 0,
    isdeci: false,
    wrongcount:0,
    edit:false
  };
  componentDidMount() {
    this.setState({ rangeValue: 100 }, () =>
      this.child.current.generateButtons()
    );
  }
  triger = (e) => {
    this.setState({ number: 0 });
    if (this.state.iscomputer) {
      this.setState(
        {
          rangeValue: e.target.value,
          computerRandom: this.randomIntFromInterval(
            e.target.value / 10,
            e.target.value
          ),
        },
        () => this.child.current.generateButtons()
      );
    } else {
      this.setState({ rangeValue: e.target.value }, () =>
        this.child.current.generateButtons()
      );
    }
  };
  handleNumber = (vari) => {
    this.setState({
      number: vari,
  
    });
    if(vari>0){
     this.setState({ edit:true})
    }
    
  };
  handleDeci = (vari) => {
    // alert('ds')
    this.setState({
      deci: vari,
    });
  };
  toggleShowNum = () => {
    if(this.state.iscomputer){
      this.setState({ ishownumber: !this.state.ishownumber });
    }
   
  };
  decimal = () => {
    this.setState(
      { deci: 0, isdeci: !this.state.isdeci, rangeValue: this.state.rangeValue },
      () => this.child.current.generateButtons(),
      this.child.current.generateDecimalButtons(!this.state.isdeci),
      this.setDecimal()
    );
  };
  setDecimal() {
    // alert(this.state.isdeci)
    if (!this.state.isdeci) {
      this.setState({
        computerDeciRandom: String(
          "000" + this.randomIntFromInterval(1, 999)
        ).slice(-3),
      });
    } else {
      this.setState({
        computerDeciRandom: 0,
      });
    }
  }
  handleComputer = (vari) => {
  
    this.setState({
      isdeci: false,
  computerDeciRandom:0,
      iscomputer: !this.state.iscomputer,
      computerRandom: this.randomIntFromInterval(
        this.state.rangeValue / 10,
        this.state.rangeValue
      ),
    },
    this.alwaysshow()
    
    );
    this.child.current.generateButtons();
    clicksound.play();
  };

  alwaysshow=()=>{
   
    if(this.state.iscomputer){
      this.setState({ishownumber:true})
    }
    else{
      this.setState({    ishownumber:false,})
    }
  }
  validate = () => {
    if (
      this.state.computerRandom == this.state.number &&
      this.state.computerDeciRandom == this.state.deci
    ) {
      if (this.state.validated == false) {
        this.setState({ wins: this.state.wins + 1 });
      }
      this.setState({wrongcount:0})
      successsound.play();
      this.setState({ validated: true });
    } else {
      this.setState({ fails: this.state.fails + 1 });
      this.setState({wrongcount:this.state.wrongcount+1})
      wrongsound.play();

    }
    this.setState({edit:false})
    // clicksound.play();
  };

  genNum() {

    let html = null;
    if (this.state.isdeci) {
      html = <small>,{String("000" + this.state.deci).slice(-3)}</small>;
    } else {
      html = null;
    }
    return (
      <h1 className="num">
        {this.state.ishownumber
          ? this.numberWithSpaces(this.state.number)
          : null}
        {this.state.ishownumber ? html : null}
      </h1>
    );
  }
  reset = () => {
   

    if(this.state.iscomputer){
      this.child.current.generateButtons();
      this.child.current.generateDecimalButtons()
    }
    else{
      this.setState({
        computerDeciRandom: 0,
      });
   
    this.setState({
      computerRandom: 0,
      iscomputer:false,
      ishownumber:true,
      isdeci:false,
      validated: false,
      number: 0,
      deci: 0,
      wrongcount:0
    });
    this.child.current.generateButtons();
    this.child.current.generateDecimalButtons()
    }
   ;




  };
  numberWithSpaces(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }
  nextNumber = () => {
    if (this.state.isdeci) {
      this.setState({
        computerDeciRandom: this.randomIntFromInterval(1, 999),
      });
    } else {
      this.setState({ computerDeciRandom: 0 });
    }
    this.setState({
      computerRandom: this.randomIntFromInterval(
        this.state.rangeValue / 10,
        this.state.rangeValue
      ),

      validated: false,
      number: 0,
      deci: 0,
      wrongcount:0
    });
    this.child.current.generateButtons();
    this.child.current.generateDecimalButtons();
  };
  randomIntFromInterval(min, max) {
    // min and max included
    return Math.floor(Math.random() * (max - min + 1) + min);
  }
  // generateComNumber=()=>{
  //   this.setState({computerRandom:this.randomIntFromInterval(this.state.rangeValue/10,this.state.rangeValue)})
  // }
  render() {
    const {
      rangeValue,
      iscomputer,
      number,
      computerRandom,
      wins,
      decitext,
      isdeci,
      fails,
      wrongcount,
      computerDeciRandom,
      edit
    } = this.state;

    var options = (
      <select
        className="form-control range"
        value={rangeValue}
        onChange={(event) => this.triger(event)}
      >
        <option value="100">100</option>
        <option value="1000">1000</option>
        <option value="10000">10000</option>

        <option value="100000">100000</option>
        <option value="1000000">1000000</option>
        <option value="10000000">10000000</option>
        <option value="100000000">100000000</option>
        <option value="1000000000">1000000000</option>
      </select>
    );

    if (this.state.isdeci) {
      options = (
        <select
          className="form-control range"
          value={rangeValue}
          onChange={(event) => this.triger(event)}
        >
          <option value="100">100</option>
          <option value="1000">1000</option>
          <option value="10000">10000</option>
        </select>
      );
    }

    return (
      <div className="App ">
        <div className="container-fluid">
          <div className="row wrapper">
            <div className="col-md-4">
              <ButtonGroup
                com={iscomputer}
                handler={this.handleNumber}
                handler1={this.handleDeci}
                ref={this.child}
                value={rangeValue}
                isdeci={this.state.isdeci}
              />
            </div>
            <div className="col-md-5 num-con">
            {iscomputer && (
                  <h1 className="com-rand">
                    <small>Find... </small>
                    { this.numberWithSpaces( computerRandom)}
                    <span className="dpart">
                      {computerDeciRandom == 0 ? "" : "," + computerDeciRandom}
                    </span>
                   
                  </h1>
                )}
              <div className="center-con">
             <h2 className="lastchance">  {this.state.wrongcount>=2? <img src='/trovailnumero/last.png' />:""}</h2>
                {this.genNum()}
              </div>

              
            </div>

            <div className="col-md-3 menu-con">
              <div className="menu">
                <img src="logo3rs.png" className="logo"></img>
                {options}
                {/* <button className="colored menu-icon">
                <i className="fa fa-bars" aria-hidden="true"></i>
              </button> */}

                <button
                  onClick={this.toggleShowNum}
                  className="colored decitext "
                >
                  123
                </button>
                <button
                  style={
                    iscomputer
                      ? { background: "#ff3503", color: "white" }
                      : { background: "white", color: "#ff3503" }
                  }
                  onClick={this.handleComputer}
                  className="colored"
                >
                  <i className="fa fa-desktop" aria-hidden="true"></i>
                </button>

                <button className="colored">
                  <i
                    onClick={this.reset}
                    className="fa fa-refresh"
                    aria-hidden="true"
                  ></i>
                </button>

                <button
                  style={{ fonSize: 20 }}
                  onClick={this.decimal}
                  className="colored decitext"
                >
                  {isdeci ? "000" : "0,00"}
                </button>
                <div>
                <div>
                  {iscomputer && (
                    <div className="counter">
                      {" "}
                      <span className="win">{wins}</span> <span>/</span>{" "}
                      <span className="fail">{fails}</span>{" "}
                    </div>
                  )}
                </div>

                {iscomputer && (
                  <div>


                    {
                       wrongcount>=3 || edit==false? 
                       <button  className="colored rounded disabled">
                       <i className="fa fa-check" aria-hidden="true"></i>
                     </button>
                       
                       :
                       
                       
                       <button  onClick={this.validate}     className="colored rounded val-btn">
                       <i className="fa fa-check" aria-hidden="true"></i>
                     </button>
                       
                       
                    }
                  


                    <button 
                      onClick={this.nextNumber}
                      className="img-btn"
                    >
                     <img src='/trovailnumero/blue-arrow.png' />
                    </button>
                  </div>
                )}
              </div>
                {/* <button className="colored">
                <i className="fa fa-flag-checkered" aria-hidden="true"></i>
              </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default App;
